export default __webpack_public_path__ + "static/flare-9a6b72a6cebfc36b7947abcd74852198.png";